import { Link } from 'react-router-dom';
import './Home.css';
import logo_decay from "./decay/logo_decay.png";
import logo_httc from "./hail_to_the_chief/logo_httc.png";

function Home() {
  return (
    <main className='Home'>
      <Link to='hail-to-the-chief' className='Home-Content'>
        <img src={logo_httc} className='Home-ContentImage' type="image/png" alt="The logo of the game titled 'Hail to
        the Chief', which consists of the name of the game superimposed on a blue, white, and red background. A single
        five-pointed start lies between the words 'to' and 'the'." />
        <p className='Home-ContentCaption'>
          Hail to the Chief - Early Access TBC
        </p>
      </Link>
      <Link to='decay' className='Home-Content'>
        <img src={logo_decay} className='Home-ContentImage' type="image/png" alt="The logo of the game titled 'Decay', 
        which consists of a dark grey letter 'D' with slices removed from the lower half, as if the letter itself is
        decaying." />
        <p className='Home-ContentCaption'>
          Decay
        </p>
      </Link>
    </main>
  );
}

export default Home;
